/**
 * Header Search Toggle
 * Handles search bar visibility and interactions
 */

export function initHeaderSearch() {
  const searchToggle = document.querySelector('.header-search-toggle');
  const searchBar = document.querySelector('.header-search-bar');
  const searchInput = searchBar?.querySelector('input[type="search"]');
  
  if (!searchToggle || !searchBar) return;
  
  // Toggle search bar on click
  searchToggle.addEventListener('click', () => {
    const isActive = searchBar.classList.toggle('is-active');
    searchToggle.classList.toggle('is-active');
    
    // Focus input when opening
    if (isActive && searchInput) {
      setTimeout(() => searchInput.focus(), 300);
    }
  });
  
  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchBar.classList.contains('is-active')) {
      searchBar.classList.remove('is-active');
      searchToggle.classList.remove('is-active');
    }
  });
  
  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!searchBar.contains(e.target) && !searchToggle.contains(e.target)) {
      if (searchBar.classList.contains('is-active')) {
        searchBar.classList.remove('is-active');
        searchToggle.classList.remove('is-active');
      }
    }
  });
}
